<template>
  <span class="store-item-icon">
    <template v-if="type === 'target'">
      <lucide-icon name="target" />
    </template>
    <template v-else-if="type === 'resource'">
      <lucide-icon name="resource" />
    </template>
    <template v-else-if="type === 'index'">
      <lucide-icon name="index" />
    </template>

    <template v-else-if="type === 'action'">
      <lucide-icon name="action" />
    </template>
    <template v-else-if="type === 'incident'">
      <lucide-icon name="incident" />
    </template>
    <template v-else-if="type === 'impulse'">
      <lucide-icon name="impulse" />
    </template>
    <template v-else-if="type === 'sceneNode'">
      <template v-if="item && 'dataType' in item">
        <template v-if="item.dataType === 'element'">
          <lucide-icon v-if="hasSubPath(item, 'data.elementUid') && typeof item.data.elementUid === 'string' && item.data.elementUid.startsWith('target_')" name="target" />
          <lucide-icon v-if="hasSubPath(item, 'data.elementUid') && typeof item.data.elementUid === 'string' && item.data.elementUid.startsWith('resource_')" name="resource" />
          <lucide-icon v-if="hasSubPath(item, 'data.elementUid') && typeof item.data.elementUid === 'string' && item.data.elementUid.startsWith('index_')" name="index" />
        </template>
        <template v-if="item.dataType === 'medium'">
          <lucide-icon name="image" />
        </template>
        <template v-else-if="item.dataType === 'layer'">
          <lucide-icon v-if="hasSubPath(item, 'data.layerType') && item.data.layerType == 'links'" name="share-2" />
          <lucide-icon v-else-if="hasSubPath(item, 'data.layerType') && item.data.layerType == 'foreground'" name="laptop-minimal" />
          <lucide-icon v-else name="layers-2" />
        </template>
        <template v-else-if="item.dataType === 'shape'">
          <lucide-icon name="square" />
        </template>
        <template v-else-if="item.dataType === 'group'">
          <lucide-icon name="group" />
        </template>
        <template v-else-if="item.dataType === 'chart'">
          <lucide-icon name="chart-line" />
        </template>
        <template v-else-if="item.dataType === 'text'">
          <lucide-icon name="type" />
        </template>
      </template>
    </template>
  </span>
</template>

<script setup lang="ts">
import LucideIcon from "@core/ui/LucideIcon.vue";

defineProps<{
  type: string;
  item?: object | null;
}>();

// Type helper to represent an object with a guaranteed nested path
type HasPath<T, P extends string> = T & (
  P extends `${infer K}.${infer Rest}`
    ? K extends string ? { [key in K]: HasPath<unknown, Rest> } : never
    : P extends string ? { [key in P]: unknown } : never
);

function hasSubPath<T extends object, P extends string>(
  obj: T,
  path: P
): obj is HasPath<T, P> {
  const parts = path.split(".");
  let current: any = obj;

  for (const part of parts) {
    if (current && typeof current === "object" && part in current) {
      current = current[part];
    } else {
      return false;
    }
  }

  return true;
}
</script>

<style>
.store-item-icon {
  display: inline-block;
  width: 0.75em;
  height: 1em;
  line-height: 1em;
  margin-right: 0.5em;
  color: var(--color-text-light);
  text-align: center;
}
</style>
